var showLabelOnFocus = function () {
    $("input.form-control").focus(function () {
        var label = $(this).parent().find('label > span');
        if (label && label.length > 0)
        {
            label.addClass("visible");
        }
    }).focusout(function () {
        var label = $(this).parent().find('label > span');
        if (label && label.length > 0)
        {
            label.removeClass("visible");
        }
    });
};

DefaultValidation = function () {
    var initCustomMethods = function () {
        let isPolishLangVersion = jQuery('html').attr('lang') === 'pl-pl';

        jQuery.validator.addMethod("exactlength", function (value, element, param) {
            return this.optional(element) || value.length == param;
        }, $.validator.format("Proszę o podanie {0} znaków."));

        jQuery.validator.addMethod("pwcheck", function (value, element, param) {
            if (value) {
                return /^(?=.*\d)(?=.*[@#\-_$%^&+=§!\?])(?=.*[a-z])(?=.*[A-Z])[0-9A-Za-z@#\-_$%^&+=§!\?]{8,20}$/.test(value);
            }
            return true;
        }, $.validator.format(
            isPolishLangVersion
                ? "Hasło musi mieć przynajmniej 8 znaków i zawierać przynajmniej 1 wielką literę, 1 cyfrę i 1 znak specjalny."
                : "Password must contain at least one digit, one special character, one lower case and one upper case letter."
        ));
    };

    var init = function () {
        var e = $("form.with-validation");
        var r = $(".alert-danger", e);
        var i = $(".alert-success", e);

        if (e.length > 0) {
            e.validate({
                errorElement: "span",
                errorClass: "error-message",
                focusInvalid: !1,
                ignore: "",
                rules: {}, //in views
                invalidHandler: function (form, validator) {
                    i.hide();

                    $('html, body').animate({
                        scrollTop: e.offset().top}, 1000);
                },
                errorPlacement: function (error, element) {
                    error.appendTo(element.parent());
                },
                highlight: function (e) {
                    $(e).closest(".form-group").removeClass("has-success").addClass("has-error")
                },
                unhighlight: function (e) {
                },
                success: function (e, r) {
                    $(r).closest(".form-group").removeClass("has-error").addClass("has-success");
                },
                submitHandler: function (e) {
                    i.show();
                    r.hide();
                    e[0].submit();
                }
            });
        }
    }

    return {
        init: function (selector, rules) {
            initCustomMethods();
            init(selector, rules);
        }
    };
}();

$(document).ready(function () {
    showLabelOnFocus();
    if (jQuery.validator) {
        DefaultValidation.init();
    }
});